import Header from "components/Header";
import { useIntegrations } from "hooks/useIntegrations";
import MainLayout from "layouts/Main";
import UserSettingItem from "../modules/UserSettingItem";
import styles from "./style.module.scss";

export default function Integrations() {
  const { integrations } = useIntegrations();

  return (
    <MainLayout
      desktopTitle="Integrations"
      customHeader={<Header label="Integrations" headerIcon=" " isHideDesktop />}
      hideNavigation
      className={styles.integrationsContainer}>
      {integrations.length ? (
        <div className={styles.list}>
          {integrations.map((item) => (
            <UserSettingItem key={item.id} data={item} />
          ))}
        </div>
      ) : (
        <p className={styles.empty}>
          No integrations are switched on for your account. Contact HaulPay to set one up.
        </p>
      )}
    </MainLayout>
  );
}
